/**
* Copyright by: 

* by ESS-Ehrhardt Software Solutions & Service GmbH
* Basselscheider Str. 55
* D-56281 Emmelshausen
* +49 (0) 67 42 / 87 27 0
* info@epg.com
*/
import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'record-text',
  templateUrl: './record-text.component.html',
  styleUrls: ['./record-text.component.scss'],
  standalone: false
})
export class RecordTextComponent implements OnInit {
  @Input() text?: string = '';

  constructor() {}

  ngOnInit(): void {}
}
